import { useEffect } from 'react';
import axios from "axios";
import * as AuthActions from '../Redux/Auth/AuthActions';
import { useGlobalDispatch } from "../Hooks/useDispatchGlobal";

export function setAuthToken(token) {
  if (token) {
    axios.defaults.headers.common["token"] = token;
  } else {
    delete axios.defaults.headers.common["token"];
  }
}

export function useUnauthorizedInterceptor() {
  const dispatch = useGlobalDispatch();
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          dispatch(AuthActions.logout());
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [dispatch]);
}

function MyComponent() {
  useUnauthorizedInterceptor();
}
